import {Component, OnInit, Renderer, ViewChild} from '@angular/core';
import {Router, ActivatedRoute, Params, ParamMap} from '@angular/router';
import {AuthService} from '../../services/auth.service';
import Swal from 'sweetalert2';
import {AccessControlService} from 'src/app/services/access-control.service';
import {CheckPermissionService} from 'src/app/services/check-permission.service';
import {ToastrService} from 'ngx-toastr';
import {MatPaginator, MatTableDataSource, MatSort} from '@angular/material';
import {RoleTypeEnum} from 'src/app/enum/roles.enum';
import {map} from 'rxjs/operators';

@Component({
  selector: 'app-role-listing',
  templateUrl: './role-listing.component.html',
  styleUrls: ['./role-listing.component.css']
})
export class RoleListingComponent implements OnInit {
  roleList: any = [];
  is_add: boolean = true;
  static is_edit: boolean = true;
  static is_delete: boolean = true;
  app_id: any;
  application: any = [];
  application_name: any;
  static is_permission: boolean = true;
  application_code: any;
  displayedColumns: string[] = ['name', 'description', 'created_by', 'Actions'];
  isLoading: boolean;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource: MatTableDataSource<any>;
  noData: any;
  mode: RoleTypeEnum;
  clientId: any;

  constructor(private renderer: Renderer,
              private router: Router,
              private authService: AuthService,
              private accessControlService: AccessControlService,
              private checkPermissionService: CheckPermissionService,
              private activatedRoute: ActivatedRoute,
              private accesscontrolService: AccessControlService,
              private toastrService: ToastrService) {
    this.application_name = this.activatedRoute.snapshot.queryParams['appname'] || 'Application';
    this.mode = localStorage.getItem('type') == '0' ? RoleTypeEnum.ORGANIZATION_ROLE : RoleTypeEnum.CLIENT_ROLE;
  }

  ngOnInit() {
    if (this.mode == RoleTypeEnum.CLIENT_ROLE) {
      this.clientId = localStorage.getItem('org_id');
    } else {
      this.activatedRoute.queryParamMap.subscribe((params: ParamMap) => {
        this.clientId = params.get('org_id');
      });
    }
    this.activatedRoute.paramMap.subscribe((url: any) => {
      this.app_id = url.params.id;
    });
    if (this.app_id) {
      this.populateRoleGrid();
    }
    // this.listallRoles_withinApp();
  }

  populateRoleGrid() {
    this.isLoading = true;
    this.authService.listRolesOfClientForApplication(this.app_id, this.clientId).subscribe((response: any) => {
      this.dataSource = new MatTableDataSource<any>(response);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.isLoading = false;
      this.noData = this.dataSource.connect().pipe(map(data => data.length === 0));

    }, error => {
      this.isLoading = false;
      this.toastrService.error(error.error);
    });
  }

  // listallRoles_withinApp() {
  //   this.authService.listallRoles_withinApp(this.app_id).subscribe((res: any) => {
  //     this.dataSource = new MatTableDataSource<any>(res);
  //     // this.dataSource.sortingDataAccessor = (item, property) => {
  //     //   switch(property) {
  //     //     case 'Email': return item.email_id;
  //     //     case 'Username': return item.username;
  //     //     case 'Status': return item.status;
  //     //     case 'Latest Login': return item.latestLoginDate;
  //     //     default: return item['username'];
  //     //   }
  //     // };
  //     this.dataSource.paginator = this.paginator;
  //     this.dataSource.sort = this.sort;
  //     // this.dataSource.filterPredicate = function (data, filter): boolean {
  //     //   return data.userDetails.email_id.toLowerCase().includes(filter) || data.userDetails.username.toLowerCase().includes(filter) ||
  //     //     data.selectedRolelist.join(',').toLowerCase().includes(filter);
  //     // };
  //   }, error => {

  //   }, () => {
  //   })
  // }
  addRoute() {
    this.router.navigate(['add-roles'], {queryParams: {opt: 'add', app_id: this.app_id, appname: this.application_name}});
  }

  delete(id: any) {
    Swal({
      title: 'Are you sure you want to delete this role?',
      text: 'You won\'t be able to revert this!',
      type: 'warning',
      width: '30%',
      showCancelButton: true,
      confirmButtonColor: 'text-danger',
      cancelButtonColor: '#f8ac59',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {
        this.authService.deleteRole(id).subscribe((res: any) => {
            if (res.error) {
              this.toastrService.error(res.errorMessage);
            } else {
              this.toastrService.success(res.success);
            }
          }, error => {
            this.toastrService.error(error.error.errorMessage);
          },
          () => {
            this.populateRoleGrid();
          });
      }

    });
  }

  applyFilter(event: Event) {
    this.noData = this.dataSource.connect().pipe(map(data => data.length === 0));
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}

